import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { BeneficiariService } from '../beneficiari.service';
import { Beneficiar, BeneficiarAdd } from '../beneficiari.interface';

@Component({
    selector: 'app-add-beneficiar',
    templateUrl: './add-beneficiar.component.html',
    styleUrls: ['./add-beneficiar.component.scss']
})
export class AddBeneficiarComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    public maxDate: Date = new Date()

    form: FormGroup = new FormGroup({
        first_name: new FormControl('', [Validators.required]),
        last_name: new FormControl('', [Validators.required]),
        birth_date: new FormControl('', [Validators.required]),
        cnp: new FormControl('', [Validators.pattern('[0-9]{13}')]),
        telefon: new FormControl('', [Validators.pattern(/^(\+4)?\d{10}$/)]),
        email: new FormControl('', [Validators.email]),
        observatii: new FormControl('', [Validators.maxLength(500)]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddBeneficiarComponent>,
        private beneficiariService: BeneficiariService,
        private notificationService: NotificationService,
        private authService: AuthService,
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.beneficiariService.setToken(token);
        });
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    submitForm() {
        this.isLoading = true;

        const { first_name, last_name, birth_date, cnp, email, telefon, observatii } = this.form.value as any;

        const newBeneficiar: BeneficiarAdd = {
            first_name,
            last_name,
            birth_date: birth_date ? this.formatDate(birth_date) : '',
            cnp,
            email,
            telefon,
            observatii
        };

        this.beneficiariService
            .addBeneficiar(newBeneficiar)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
